import { css } from '@emotion/core';
import HomeContent from './HomeContent';

export default function HomeLayoutDesktop() {
    return (
        <div
            css={css`
                padding: 24px;
                flex-grow: 1;
                display: flex;
                flex-direction: column;
            `}
        >
            <HomeContent />
        </div>
    );
}
